import { useState, useMemo } from "react";
import type { Client } from "@/mocks/configuracoes";
import SettingsStatusBadge from "./SettingsStatusBadge";

interface ClientsTableProps {
  clients: Client[];
}

const typeLabels: Record<string, string> = {
  "prefeitura": "Prefeitura",
  "secretaria": "Secretaria",
  "loteadora": "Loteadora",
  "condomínio": "Condomínio",
  "consultoria": "Consultoria",
  "empresa privada": "Empresa privada",
  "órgão público": "Órgão público",
  "outro": "Outro",
};

export default function ClientsTable({ clients }: ClientsTableProps) {
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    return clients.filter((c) => {
      if (search) {
        const q = search.toLowerCase();
        if (!c.name.toLowerCase().includes(q) && !c.document.includes(q) && !c.municipality.toLowerCase().includes(q)) return false;
      }
      return true;
    });
  }, [clients, search]);

  return (
    <div className="space-y-4">
      <div className="relative max-w-sm">
        <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
        <input type="text" placeholder="Buscar cliente..." value={search} onChange={(e) => setSearch(e.target.value)} className="w-full pl-9 pr-4 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200">
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Nome</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Tipo</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">CNPJ/CPF</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Município/UF</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Contato</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Projetos</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Status</th>
              <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Ações</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((c) => (
              <tr key={c.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="py-2.5 px-3 text-foreground-900 font-medium">{c.name}</td>
                <td className="py-2.5 px-3 text-foreground-600 text-xs">{typeLabels[c.type] || c.type}</td>
                <td className="py-2.5 px-3 text-foreground-500 text-xs">{c.document}</td>
                <td className="py-2.5 px-3 text-foreground-600 text-xs">{c.municipality}/{c.state}</td>
                <td className="py-2.5 px-3 text-foreground-500 text-xs">{c.contact}</td>
                <td className="py-2.5 px-3">
                  <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold">{c.projectCount}</span>
                </td>
                <td className="py-2.5 px-3"><SettingsStatusBadge status={c.status} /></td>
                <td className="py-2.5 px-3">
                  <button className="w-8 h-8 rounded-lg hover:bg-background-100 flex items-center justify-center text-foreground-400 hover:text-primary-600 transition-colors" title="Editar">
                    <i className="ri-edit-line text-sm" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}